var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z",
    fill: "white",
    stroke: "#13C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3158 16.4263C23.1032 11.4695 18.9337 9 15.1579 9C11.3821 9 8 11.9079 8 15.4868C8 17.1779 8.71579 18.7168 9.87895 19.8711L9.34211 22.7968L12.5274 21.5621C13.9321 21.9826 15.2563 22.09 16.5 21.8753",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3158 16.4263C23.1032 11.4695 18.9337 9 15.1579 9C11.3821 9 8 11.9079 8 15.4868C8 17.1779 8.71579 18.7168 9.87895 19.8711L9.34211 22.7968L12.5274 21.5621C13.9321 21.9826 15.2563 22.09 16.5 21.8753",
    stroke: "#13C2C2",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 14.9769C13.082 14.9769 13.5294 14.5206 13.5294 13.9659C13.5294 13.4111 13.082 12.9548 12.5273 12.9548C11.9726 12.9548 11.5252 13.4111 11.5252 13.9659C11.5252 14.5206 11.9726 14.9769 12.5273 14.9769Z",
    fill: "#13C2C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7437 14.9769C18.2984 14.9769 18.7458 14.5206 18.7458 13.9659C18.7458 13.4111 18.2984 12.9548 17.7437 12.9548C17.189 12.9548 16.7416 13.4111 16.7416 13.9659C16.7416 14.5206 17.189 14.9769 17.7437 14.9769Z",
    fill: "#13C2C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1032 23.0743C22.3247 23.5843 21.3495 23.8885 20.3026 23.8885C17.7079 23.8885 15.6053 22.0364 15.6053 19.7548C15.6053 17.4732 17.7079 15.6211 20.3026 15.6211C22.8974 15.6211 25 17.4732 25 19.7548C25 20.3811 24.839 20.9806 24.5526 21.5174",
    fill: "#13C2C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5523 21.5173L24.9997 23.8884L23.1029 23.0742",
    fill: "#13C2C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9849 19.1552C21.636 19.1552 21.3586 18.8779 21.3586 18.5289C21.3586 18.18 21.636 17.9026 21.9849 17.9026C22.3338 17.9026 22.6112 18.18 22.6112 18.5289C22.6112 18.8779 22.3338 19.1552 21.9849 19.1552Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9337 19.1552C18.5848 19.1552 18.3074 18.8779 18.3074 18.5289C18.3074 18.18 18.5848 17.9026 18.9337 17.9026C19.2827 17.9026 19.56 18.18 19.56 18.5289C19.56 18.8779 19.2827 19.1552 18.9337 19.1552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeChat);
export default __webpack_public_path__ + "static/media/WeChat.d3859f421842e933fbc6adfe6d445370.svg";
export { ForwardRef as ReactComponent };